module.exports = __webpack_public_path__ + "img/passo1.46004d13.gif";